
let navbar = {
    run: () => {

        const myID = document.getElementById("brand");

        const myScrollFunc = function () {
            const y = window.scrollY;
            if (y >= 50) {
                myID.className = "navbar-brand d-block"
            } else {
                myID.className = "navbar-brand d-none"
            }
        };

        window.addEventListener("scroll", myScrollFunc);

        const navbarTogglable = document.querySelectorAll('.navbar-togglable');
        const navbarCollapse = document.querySelectorAll('.navbar-collapse');
        const windowEvents = ['load', 'scroll'];

        function navbarOnTop(navbar)
        {
            navbar.classList.remove('navbar-light');
            navbar.classList.add('navbar-dark');
            navbar.classList.remove('shadow');
            navbar.classList.remove('bg-white');
            navbar.style.top = "0";
            navbar.style.zIndex = "1900";
        }

        function navbarScrolling(navbar)
        {
            navbar.classList.remove('navbar-dark');
            navbar.classList.add('navbar-light');
            navbar.classList.add('bg-white');
            navbar.classList.add('shadow');
            navbar.style.top = "-53px";
            navbar.style.zIndex = "2200";
        }

        function toggleNavbar(navbar)
        {
            const scrollTop = window.pageYOffset;

            if (scrollTop) {
                navbarScrolling(navbar);
            }

            if (!scrollTop) {
                navbarOnTop(navbar);
            }
        }

        function overflowHide()
        {
            const scrollbarWidth = getScrollbarWidth();

            document.documentElement.style.overflow = 'hidden';
            document.body.style.paddingRight = scrollbarWidth + 'px';
        }

        function overflowShow()
        {
            document.documentElement.style.overflow = '';
            document.body.style.paddingRight = '';
        }

        function getScrollbarWidth()
        {
            return window.innerWidth - document.documentElement.clientWidth;
        }

        navbarTogglable.forEach(function (navbar) {
            windowEvents.forEach(function (event) {
                window.addEventListener(event, function () {
                    toggleNavbar(navbar);
                });
            });
        });

        navbarCollapse.forEach(function (collapse) {
            collapse.addEventListener('show.bs.collapse', function () {
                overflowHide();
            });

            collapse.addEventListener('hidden.bs.collapse', function () {
                overflowShow();
            });
        });

    }
}

export default navbar
